import { render } from "./ProjectSummaryBoxHeader.vue?vue&type=template&id=c8987258"
import script from "./ProjectSummaryBoxHeader.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryBoxHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__